import { buildConnectConfig } from '@/common/bot/lib';

/**
 * Connect config used when a Voice AI session hands off to a human:
 * enables every support channel so the user can pick how to continue.
 */
export const getVoiceAiFallbackConfig = () => {
  return buildConnectConfig({
    connect: true,
    liveChat: true,
    voiceChat: true,
    openRequest: true,
    loginRequired: false,
    showDescriptionBox: false,
  });
};
